import React from "react";
import Context from "../../../Context";
import SuperSelect from "../../Misc/SuperSelect";
import EssenceReferenceShipEdit from "../../Essence/EssenceReferenceShipEdit";

export default class CertificateShipSelect extends React.Component {
  static contextType = Context;

  onChange = (shipId) => {
    this.context.redirect(`/certificate/${shipId}/`);
  };

  render() {
    return (
      <>
        <SuperSelect
          defaultValue={this.props.shipId}
          onChange={(value) => this.onChange(value)}
          essence="ship"
          placeholder="Выберите судно..."
          nameField="name"
          idField="id"
          refBtnClass="btn-white"
          reference={{
            title: "Суда",
            essence: "ship",
            showDescription: true,
            showType: true,
            itemEditor: (itemEditorProps) => (
              <EssenceReferenceShipEdit {...itemEditorProps} />
            ),
          }}
        />
      </>
    );
  }
}
